import React, { Component } from 'react';
import Bottom_Menu_Bar from '../Bottom_Menu_Bar/Bottom_Menu_Bar';
import Bottom_Controls_Bar from '../Bottom_Controls_Bar/Bottom_Controls_Bar';
// import { Swipeable } from 'react-swipeable';
import QRScanner_Controls from '../Part_Sample/QRScanner_Controls';
import Toast from '../Part_Sample/Toast';
import MSM_Site_Name from '../Part_Sample/MSM_Site_Name';
import { navigateDashboard, navigateGroups, navigateScenes, navigateReport, navigateSystem } from '../Common/navigation';
import { addAnimation, isEmpty } from '../Common/Common';

// Bottom Menu
import Groups from '../Group/Groups';
import System from '../System/System';
import Dashboard from '../Dashboard/Dashboard';
import Scenes from '../Scenes/Scenes';
import Reports from '../Reports/Reports';

// Before Login
import Login_Page from '../Login/Login_Page';
import Launch_Screen from '../Onboarding/Launch_Screen';
import Select_Language from '../Onboarding/Select_Language';
import Terms_and_Conditions from '../Onboarding/Terms_and_Conditions';
import Find_Controller from '../Onboarding/Find_Controller';
import QR_Scanner from '../System/QR/QR_Scanner';

// Groups
import Group_Details from '../Group/Group_Details/Group_Details';
import Group_Edit from '../Group/Add_Edit_Group/Group_Edit';
import Optional_Group_Display from '../Group/Add_Edit_Group/Optional_Group_Display';
import Operation_Screen from '../Group/Group_Details/Operation/Operation_Screen';
import Group_Operation_Screen from '../Group/Group_Details/Operation/Group_Operation_Screen';

// Schedule
import Schedule from '../System/Schedule/Schedule';
import Schedule_Office_Summary from '../System/Schedule/Office/Schedule_Office_Summary';
import Add_Edit_Pattern from '../System/Schedule/Pattern/Add_Edit_Pattern';
import Add_Edit_Action from '../System/Schedule/Pattern/Add_Edit_Action';
import Add_Edit_Calendar from '../System/Schedule/Calendar/Add_Edit_Calendar';
import Add_Edit_Schedule_Home from '../System/Schedule/Home/Add_Edit_Schedule_Home';

import Schedule_Step1_Name from '../System/Schedule/Office/Schedule_Step1_Name';
import Schedule_Step2_Target from '../System/Schedule/Office/Schedule_Step2_Target';
import Schedule_Step3_Pattern from '../System/Schedule/Office/Schedule_Step3_Pattern';
import Schedule_Step4_Execute_Days from '../System/Schedule/Office/Schedule_Step4_Execute_Days';

// Interlock
import Interlock from '../System/Interlock/Interlock';
import Interlock_Step1_Name from '../System/Interlock/Interlock_Step1_Name';
import Interlock_Summary from '../System/Interlock/Interlock_Summary';
import Edit_Interlock_Input from '../System/Interlock/Edit_Interlock_Input';
import Add_Edit_Input_Condition from '../System/Interlock/Add_Edit_Input_Condition';
import Add_Edit_Condition_Detail from '../System/Interlock/Add_Edit_Condition_Detail';
import Add_Edit_Output_Action from '../System/Interlock/Add_Edit_Output_Action';

// System Settings
// Scene
import Scene_Settings from '../System/Scene_Settings/Scene_Settings';
import Add_Edit_Scene from '../System/Scene_Settings/Add_Edit_Scene';
import Add_Edit_Scene_Command from '../System/Scene_Settings/Add_Edit_Scene_Command';
// User Administration
import User_Administration from '../System/User_Administration/User_Administration';
import Add_Edit_Account from '../System/User_Administration/Add_Edit_Account';
import MSM_Add_Edit_Account from '../System/User_Administration/MSM/MSM_Add_Edit_Account';

// Layout
import Layout from '../Layout/Layout';
import Layout_Editor from '../System/Layout_Editor/Layout_Editor';
import Edit_Layout from '../System/Layout_Editor/Edit_Layout';

// Point Settings
import Point_Settings from '../System/Point_Settings/Point_Settings';
import Edit_Point_Settings from '../System/Point_Settings/Edit_Point_Settings';
// Changeover
import Changeover from '../System/Changeover/Changeover';
import Add_Edit_Changeover from '../System/Changeover/Add_Edit_Changeover';
// Language
import Language from '../System/Language/Language';
// Password
import Password from '../System/Password/Password';
// QR Code
import QR_Generator from '../System/QR/QR_Generator';
// IAQ_Monitoring_Screen
import IAQ_Monitoring from '../IAQ_Monitoring/IAQ_Monitoring';
import IAQ_Mon_Details from '../IAQ_Monitoring/IAQ_Mon_Details';
// IAQ Monitoring Settings
import IAQ_Monitoring_Settings from '../System/IAQ_Monitoring_Settings/IAQ_Monitoring_Settings';
import Add_Edit_IAQ from '../System/IAQ_Monitoring_Settings/Add_Edit_IAQ';
import Add_Edit_IAQ_Devices from '../System/IAQ_Monitoring_Settings/Add_Edit_IAQ_Devices';
// History
import History from '../System/History/History';
import History_Change_Filter from '../System/History/History_Change_Filter';
// MSM
import MSM_Settings from '../System/MSM_Settings/MSM_Settings';
import MSM_Settings_Sites from '../System/MSM_Settings/Sites/MSM_Settings_Sites';
import Add_Edit_Site from '../System/MSM_Settings/Sites/Add_Edit_Site';
import MSM_Settings_Regions from '../System/MSM_Settings/Regions/MSM_Settings_Regions';
import Add_Edit_Region from '../System/MSM_Settings/Regions/Add_Edit_Region';

// Reports
import Operation_Info from '../Reports/Operation_Info/Operation_Info';
import Error_Info_Report from '../Reports/Error_Info_Report/Error_Info_Report';
import Energy_Water_Management from '../Reports/Energy_Water_Management/Energy_Water_Management';
import Trend_Data from '../Reports/Trend_Data/Trend_Data';
import Trend_Data_Select_Points from '../Reports/Trend_Data/Trend_Data_Select_Points';
import Report_Settings from '../Reports/Report_Settings/Report_Settings';
import Realtime from '../Reports/Realtime/Realtime';
import RT_Energy_View from '../Reports/Real_Time_Energy_View/Real_Time_Energy_View';

//DLinkCamera
import DLinkAddEditCamera from '../System/IPCam_Settings/DLinkCamera/DLinkAddEditCamera';
import DLinkCameras from '../System/IPCam_Settings/DLinkCamera/DLinkCameras';

//Uniview
import UniviewLogin from '../System/IPCam_Settings/Uniview/UniviewLogin';
import UniviewCameras from '../System/IPCam_Settings/Uniview/UniviewCameras';
import UniviewAddCamera from '../System/IPCam_Settings/Uniview/UniviewAddCamera';
import UniviewCameraDetails from '../System/IPCam_Settings/Uniview/UniviewCameraDetails';

//IPCam_Settings
import IPCam_Settings from '../System/IPCam_Settings/IPCam_Settings';

//Billing
import Tenant_Settings from '../Reports/Billing/Tenant_Settings';
import Owner_Settings from '../Reports/Billing/Owner_Settings';
import Unit_Price_Settings from '../Reports/Billing/Unit_Price_Settings';
import Bill_Settings from '../Reports/Billing/Bill_Settings';
import Billing_Main from '../Reports/Billing/Billing_Main';
import PPD_Data from '../Reports/Billing/PPD_Data';
import Bill_Information from '../Reports/Billing/Bill_Information/Bill_Information';
import Add_Edit_Tenant from '../Reports/Billing/Add_Edit_Tenant';
import Holiday_Calendar_Settings from '../Reports/Billing/Holiday_Calendar_Settings';
import Holiday_DOW_Settings from '../Reports/Billing/Holiday_DOW_Settings';
import PPD_Data_Analysis from '../Reports/Billing/PPD_Data_Analysis/PPD_Data_Analysis';
import IDU_Hourly_Chart from '../Reports/Billing/PPD_Data_Analysis/IDU_Hourly_Chart';
import Export_PPD from '../Reports/Billing/Export_PPD/Export_PPD';

//Version Information
import Version_Information from '../System/Version/Version_Information';

// Hotel Guest Room
import Guest_Room_Overview from '../Hotel_Guest_Room/Guest_Room_Overview';
import Guest_Room_Settings from '../System/Guest_Room_Settings/Guest_Room_Settings';
import Locations from '../System/Guest_Room_Settings/Locations/Locations';
import Add_Edit_Location from '../System/Guest_Room_Settings/Locations/Add_Edit_Location';
import Rooms from '../System/Guest_Room_Settings/Rooms/Rooms';
import Edit_Guest_Room from '../System/Guest_Room_Settings/Rooms/Edit_Guest_Room';
import Control_Param from '../System/Guest_Room_Settings/Control_Param/Control_Param';

// MSM
import MSM from '../MSM/MSM';
import MSM_Transition_Screen from '../MSM/MSM_Transition_Screen';

// Google Home
//import Google_Home from '../System/Google_Home/Google_Home';
// Alexa
//import Alexa from '../System/Alexa/Alexa';

export default class Switch_Content extends Component {
	constructor(props) {
		super(props);
		this.state = {
			classname: '',
			is_show_bottom_menu: false,
			is_show_bottom_controls: false,
			is_show_content: true,
			is_show_qrscanner: false,
			is_show_toast: false,
			toast_message: '',
			toast_height: null,
		}

		this.bottom_controls_ref = React.createRef();
		this.ref = React.createRef();
		this.QR_Controls = React.createRef();
	}

	components = {
		// Add screens here when adding new screens
		Dashboard: Dashboard,
		Groups: Groups,
		Scenes: Scenes,
		Reports: Reports,
		System: System,

		Login_Page: Login_Page,
		Launch_Screen: Launch_Screen,
		Select_Language: Select_Language,
		Terms_and_Conditions: Terms_and_Conditions,
		Find_Controller: Find_Controller,

		Group_Details: Group_Details,
		Group_Edit: Group_Edit,
		Optional_Group_Display: Optional_Group_Display,
		Operation_Screen: Operation_Screen,
		Group_Operation_Screen: Group_Operation_Screen,

		Scene_Settings: Scene_Settings,
		Add_Edit_Scene: Add_Edit_Scene,
		Add_Edit_Scene_Command: Add_Edit_Scene_Command,

		Schedule: Schedule,
		Schedule_Office_Summary: Schedule_Office_Summary,
		Add_Edit_Pattern: Add_Edit_Pattern,
		Add_Edit_Action: Add_Edit_Action,
		Add_Edit_Calendar: Add_Edit_Calendar,
		Add_Edit_Schedule_Home: Add_Edit_Schedule_Home,

		Schedule_Step1_Name: Schedule_Step1_Name,
		Schedule_Step2_Target: Schedule_Step2_Target,
		Schedule_Step3_Pattern: Schedule_Step3_Pattern,
		Schedule_Step4_Execute_Days: Schedule_Step4_Execute_Days,

		Interlock: Interlock,
		Interlock_Step1_Name: Interlock_Step1_Name,
		Interlock_Summary: Interlock_Summary,
		Edit_Interlock_Input: Edit_Interlock_Input,
		Add_Edit_Input_Condition: Add_Edit_Input_Condition,
		Add_Edit_Condition_Detail: Add_Edit_Condition_Detail,
		Add_Edit_Output_Action: Add_Edit_Output_Action,

		User_Administration: User_Administration,
		Add_Edit_Account: Add_Edit_Account,
		MSM_Add_Edit_Account: MSM_Add_Edit_Account,

		Layout: Layout,
		Layout_Editor: Layout_Editor,
		Edit_Layout: Edit_Layout,

		Point_Settings: Point_Settings,
		Edit_Point_Settings: Edit_Point_Settings,

		Changeover: Changeover,
		Add_Edit_Changeover: Add_Edit_Changeover,

		Language: Language,
		Password: Password,
		QR_Generator: QR_Generator,
		QR_Scanner: QR_Scanner,

		IAQ_Monitoring: IAQ_Monitoring,
		IAQ_Mon_Details: IAQ_Mon_Details,

		IAQ_Monitoring_Settings: IAQ_Monitoring_Settings,
		Add_Edit_IAQ: Add_Edit_IAQ,
		Add_Edit_IAQ_Devices: Add_Edit_IAQ_Devices,

		MSM_Settings: MSM_Settings,
		MSM_Settings_Sites: MSM_Settings_Sites,
		MSM_Settings_Regions: MSM_Settings_Regions,
		Add_Edit_Site: Add_Edit_Site,
		Add_Edit_Region: Add_Edit_Region,

		DLinkAddEditCamera: DLinkAddEditCamera,
		DLinkCameras: DLinkCameras,

		UniviewLogin: UniviewLogin,
		UniviewCameras: UniviewCameras,
		UniviewAddCamera: UniviewAddCamera,
		UniviewCameraDetails: UniviewCameraDetails,

		IPCam_Settings: IPCam_Settings,

		Billing_Main: Billing_Main,
		PPD_Data: PPD_Data,
		Tenant_Settings: Tenant_Settings,
		Add_Edit_Tenant: Add_Edit_Tenant,
		Owner_Settings: Owner_Settings,
		Unit_Price_Settings: Unit_Price_Settings,
		Bill_Information: Bill_Information,
		Bill_Settings: Bill_Settings,
		Holiday_Calendar_Settings: Holiday_Calendar_Settings,
		Holiday_DOW_Settings: Holiday_DOW_Settings,
		PPD_Data_Analysis: PPD_Data_Analysis,
		IDU_Hourly_Chart: IDU_Hourly_Chart,
		Export_PPD: Export_PPD,

		History: History,
		History_Change_Filter: History_Change_Filter,
		Operation_Info: Operation_Info,
		Error_Info_Report: Error_Info_Report,
		Energy_Water_Management: Energy_Water_Management,
		Trend_Data: Trend_Data,
		Trend_Data_Select_Points: Trend_Data_Select_Points,
		Report_Settings: Report_Settings,
		Realtime: Realtime,
		RT_Energy_View: RT_Energy_View,

		Version_Information: Version_Information,

		Guest_Room_Overview: Guest_Room_Overview,
		Guest_Room_Settings: Guest_Room_Settings,
		Locations: Locations,
		Add_Edit_Location: Add_Edit_Location,
		Rooms: Rooms,
		Edit_Guest_Room: Edit_Guest_Room,
		Control_Param: Control_Param,

		MSM: MSM,
		MSM_Transition_Screen: MSM_Transition_Screen,

		//Google_Home:Google_Home
		//Alexa: Alexa
	};

	handleScreenAnimation = (classname) => {
		this.setState({
			classname: classname
		}, () => {
			setTimeout(() => { this.setState({ classname: '', }) }, 700);
		})
	}

	handleShowBottomMenu = () => {
		let elem = document.getElementById('bottom_menu_bar');
		//addAnimation(elem, 'flipInX', () => { }, 1000);
		this.setState({
			is_show_bottom_menu: true,
			is_show_bottom_controls: false,
		})
	}

	handleShowBottomControls = () => {
		let elem = document.getElementById('bottom_controls_bar');
		//addAnimation(elem, 'flipInX', () => { }, 1000);
		this.setState({
			is_show_bottom_menu: false,
			is_show_bottom_controls: true,
		})
	}

	handleHideBottomMenu = () => {
		this.setState({
			is_show_bottom_menu: false,
			is_show_bottom_controls: false,
		})
	}

	showQRScanner = () => {
		window.app.hideBackground();
		this.setState({
			is_show_content: false,
			is_show_qrscanner: true,
		})
	}

	hideQRScanner = () => {
		if (this.props.receiver.is_mobile) {
			window.app.showBackground();
			this.QR_Controls.current.resetControls();

			if (window.QRScanner != undefined) {
				window.QRScanner.destroy(function (status) {
					// console.log('QR Scanner destroyed');
				});
			}

			this.setState({
				is_show_content: true,
				is_show_qrscanner: false,
			})
		}
	}

	navigateSwipe = (eventData) => {
		if (eventData.event.target.id.substring(0, 8) == 'carousel' || eventData.event.target.id == '') {
			return;
		}

		switch (this.props.tag) {
			case 'Dashboard':
				if (eventData.dir == 'Left') {
					navigateGroups(eventData.dir);
					break;
				}
				break;
			case 'Groups':
				switch (eventData.dir) {
					case 'Right':
						navigateDashboard(eventData.dir);
						break;
					case 'Left':
						navigateScenes(eventData.dir);
						break;
				}
				break;
			case 'Scenes':
				switch (eventData.dir) {
					case 'Right':
						navigateGroups(eventData.dir);
						break;
					case 'Left':
						navigateReport(eventData.dir);
						break;
				}
				break;
			case 'Reports':
				switch (eventData.dir) {
					case 'Right':
						navigateScenes(eventData.dir);
						break;
					case 'Left':
						navigateSystem(eventData.dir);
						break;
				}
				break;
			case 'System':
				if (eventData.dir == 'Right') {
					navigateReport(eventData.dir);
					break;
				}
				break;
		}
	}

	render() {
		let content_handler = this.props.content_handler;
		const TagName = this.components[this.props.tag || 'Login_Page'];

		//configuration for Swipeable gesture
		const config = {
			velocityThreshold: 0.3,
			directionalOffsetThreshold: 80
		};

		// For MSM
		let is_display_site_name = false;
		let site_name = '';
		let site_name_top = 0;
		let site_name_left = 0;

		if (this.props.receiver.active_controller != null) {
			if (this.props.receiver.active_controller.active_site != '') {
				is_display_site_name = true;
				if (!isEmpty(window.app.state.site_list[this.props.receiver.active_controller.active_site])) {
					site_name = window.app.state.site_list[this.props.receiver.active_controller.active_site].attr.name;
					if (this.state.is_show_bottom_menu || this.state.is_show_bottom_controls) {
						site_name_top = this.props.height - 55 - 30;
					} else {
						site_name_top = this.props.height - 30;
					}
				}
			}
		}

		return (
			<div>
				{/* <Swipeable onSwiped={(eventData) => this.navigateSwipe(eventData)} {...config} > */}
					<Toast
						message={this.state.toast_message}
						is_show={this.state.is_show_toast}
						width={this.props.width}
						height={this.state.toast_height}
						top={10}
					/>
					<div className={this.state.classname} style={{ opacity: this.state.is_show_content ? 1 : 0 }}>
						<TagName
							receiver={this.props.receiver}
							key={this.props.tag}
							ref={this.ref}
							param={this.props.param}
							content_handler={content_handler.bind(this)}
							width={this.props.width}
							height={this.props.height}
							handleSetNotFirstTime={this.handleSetNotFirstTime}
							colours={this.props.colours}
							is_mobile={this.props.receiver.is_mobile}
						/>
					</div>
					<div style={{ display: this.state.is_show_qrscanner ? 'block' : 'none' }}>
						<QRScanner_Controls ref={this.QR_Controls} param={this.props.param} />
					</div>
					<div style={{ display: is_display_site_name ? 'block' : 'none' }}>
						<MSM_Site_Name
							site_name={site_name}
							top={site_name_top}
						/>
					</div>
					<div style={{ display: this.state.is_show_bottom_menu ? 'block' : 'none' }}>
						<Bottom_Menu_Bar
							tag={this.props.tag}
							receiver={this.props.receiver}
							colours={this.props.colours}
						/>
					</div>
					<div style={{ display: this.state.is_show_bottom_controls ? 'block' : 'none' }}>
						<Bottom_Controls_Bar
							tag={this.props.tag}
							ref={this.bottom_controls_ref}
							receiver={this.props.receiver}
							colours={this.props.colours}
							width={this.props.width}
							height={this.props.height}
							param={this.props.param}
						/>
					</div>
				{/* </Swipeable> */}
			</div>
		)
	}
}